module.exports = __webpack_public_path__ + "static/media/mb.02d54233.svg";